module.exports = __webpack_public_path__ + "static/content_3_1_dont-2b3efe93ab1efcebacd63b3e986dba28.png";